module.exports = "https://cdn-shared.mathletics.com/teacher-modules/teacher-class-management/175/assets/images/a09f1fd89f6320a31acc8db39149e0ec.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/icons/ico_new.svg
// module id = KOQ+
// module chunks = 1